<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="tab-box">
        <custom-tab-box :tabData="tabData" :selectTab="selectTab" @change="handleChangeTab"></custom-tab-box>
      </div>
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="申请时间:" prop="withdrawTime">
                <el-date-picker
                  v-model="searchForm.withdrawTime"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主归属:" prop="companyId">
                <el-select style="width: 100%" v-model="searchForm.companyId" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="item in companyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主名称:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.username"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="手机号码:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.phone"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="处理状态:" prop="status">
                <el-select style="width: 100%" v-model="searchForm.status" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="item in $dict.withdrawStatusOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="selectTab === 11 ? tableColumn1 : tableColumn2"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:status="{ row }">
          <div class="common-status status-in-progress" v-if="row.status === 1">成功</div>
          <div class="common-status status-error" v-if="row.status === -1">失败</div>
          <div class="common-status status-pending-order" v-if="row.status === 0">待处理</div>
        </template>
        <template v-slot:operation="{ row }">
          <span
            class="operate-btn"
            :class="row.status === 0 ? '' : 'disable-txt'"
            @click="row.status === 0 ? handleDeal(row) : ''">
            提现处理
          </span>
          <span class="operate-btn" @click="handleDetail(row)">详情</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";

export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      searchForm: {
        companyId: "",
        phone: "",
        status: "",
        userType: 11,
        username: "",
        withdrawTime: "",
      },
      selectTab: 11,
      tabData: [
        {
          label: 11,
          value: "货主提现申请",
        },
        {
          label: 21,
          value: "司机提现申请",
        },
      ],
      isImmediatelyGetData: true,
      haveCompany: true,

      tableColumn1: [
        {
          label: "申请时间",
          prop: "withdrawTime",
          align: "left",
          show: true,
        },
        {
          label: "货主归属",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "货主名称",
          prop: "username",
          align: "left",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "提现金额",
          prop: "withdrawAmount",
          align: "left",
          show: true,
        },
        {
          label: "处理状态",
          prop: "status",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
      tableColumn2: [
        {
          label: "申请时间",
          prop: "withdrawTime",
          align: "left",
          show: true,
        },
        {
          label: "货主归属",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "司机名称",
          prop: "username",
          align: "left",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "提现金额",
          prop: "withdrawAmount",
          align: "left",
          show: true,
        },
        {
          label: "处理状态",
          prop: "status",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleChangeTab(val) {
      this.selectTab = val;
      this.searchForm.userType = val;
      this.tableOptions.pageNumber = 1;
      this.getTableData();
    },
    handleDeal(row) {
      this.$refs.addOrEdit.init("提现处理", false, row);
    },
    handleDetail(row) {
      this.$refs.addOrEdit.init("详情", true, row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .custom-table-box {
    padding-top: 0;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
